import {
  ButtonIcon,
  EditActionIcon,
  DeleteActionIcon,
} from 'components/Ui/styled';
import { ActionWrapperBox } from 'components/Common/common.styled';
import { RoundedIconVisibility } from 'components/Ui/styled';

const renderTutoringSubjectsActions = (
  params,
  handleEdit,
  handleDelete,
  handleView
) => {
  return (
    <ActionWrapperBox>
      <ButtonIcon onClick={() => handleEdit(params)} data-testid="buttonIcon">
        <EditActionIcon />
      </ButtonIcon>
      <ButtonIcon
        onClick={() => handleView(params)}
        data-testid="deleteButtonIcon"
      >
        <RoundedIconVisibility />
      </ButtonIcon>
      <ButtonIcon
        onClick={() => handleDelete(params)}
        data-testid="deleteButtonIcon"
      >
        <DeleteActionIcon />
      </ButtonIcon>
    </ActionWrapperBox>
  );
};

export const tutoringSubjectsColumns = (
  handleEdit,
  handleDelete,
  handleView
) => [
  {
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 120,
    renderCell: (params) =>
      renderTutoringSubjectsActions(
        params,
        handleEdit,
        handleDelete,
        handleView
      ),
  },
  { headerName: 'Subject Name', field: 'subjectName', flex: 1 },
  { headerName: 'Tutor', field: 'tutor', flex: 1 },
];

export const getTutoringSubjectsListData = (
  tutoringSubjectsData,
  availableUsersList
) => {
  if (!tutoringSubjectsData || tutoringSubjectsData?.length === 0) {
    return [];
  }

  return tutoringSubjectsData.map((item) => {
    const matchedUser = availableUsersList.find(
      (user) => user?.userId === item?.tutorId
    );

    const tutorName = matchedUser
      ? `${matchedUser?.givenName} ${matchedUser?.familyName}`
      : matchedUser?.username;

    return {
      ...item,
      tutor: tutorName,
      id: item?.subjectId,
      subjectName: item?.name,
      subjectId: item?.subjectId,
    };
  });
};
